import axios from "axios";

const APIService = axios.create({
  baseURL: sessionStorage.getItem("url"),
  timeout: 5000, // Indicates 30 seconds to wait for api response
  headers: {
    "Content-Type": "application/json"
  }
});

const checkIfMaintenanceIsOn = response => {
  if (response && response.status === 503) {
    this.$router.push("/maintenance");
  }
  return response;
};

APIService.interceptors.response.use(checkIfMaintenanceIsOn);

export default APIService;
